// @flow

import generateDefaultButtonCss from './generateDefaultButtonCss';
import generateGhostButtonCss from './generateGhostButtonCss';
import generateHeroButtonCss from './generateHeroButtonCss';
import generateLinkButtonCss from './generateLinkButtonCss';
import generateLinkTextCss from './generateLinkTextCss';
import type { ButtonVariant } from '../../../types/theme';

export default (variant: ButtonVariant) => {
  switch (variant) {
    case 'ghost':
      return generateGhostButtonCss;
    case 'link':
      return generateLinkButtonCss;
    case 'hero':
      return generateHeroButtonCss;
    case 'link_text':
      return generateLinkTextCss;
    default:
      return generateDefaultButtonCss;
  }
};
